import { ItemBoxSkeleton } from '@marketplace-web/domain/item-box'

const TOTAL_ITEMS = 4

const ItemsGridSkeleton = () => {
  return (
    <div className="item-view-items">
      {Array.from({ length: TOTAL_ITEMS }).map((_, index) => (
        <div className="item-view-items__item" key={index}>
          <ItemBoxSkeleton />
        </div>
      ))}
    </div>
  )
}

export default ItemsGridSkeleton
